import type { PayloadAction } from '@reduxjs/toolkit';
import { createEntityAdapter, createSelector, createSlice } from '@reduxjs/toolkit';
import { routeApi } from '../../api/route-optimization.api';
import type { Routes, Stops } from '../../types/RouteOptimization';
import type { RootState } from '../store';

const emptyArray: any[] = [];

const routesAdapter = createEntityAdapter<Routes, string>({
  selectId: route => route.id,
});

const routesInitialState = routesAdapter.getInitialState({
  stopMap: {} as Record<string, Stops[]>,
  count: 0,
});

const initialState = {
  routes: routesInitialState,
};

export const routesReducer = createSlice({
  name: 'routesReducer',
  initialState,
  reducers: {
    removeRoute: (state, action: PayloadAction<string>) => {
      routesAdapter.removeOne(state.routes, action.payload);
      state.routes.count = Math.max(0, state.routes.count - 1);
    },
  },
  extraReducers: builder => {
    builder
      // For paginated route list (used in tables)
      .addMatcher(routeApi.endpoints.getRoutes.matchFulfilled, (state, action) => {
        routesAdapter.setAll(state.routes, action.payload.results);
        state.routes.count = action.payload.count;
      })
      //For Stops entire route
      .addMatcher(routeApi.endpoints.getStops.matchFulfilled, (state, action) => {
        const routeId = action.meta.arg.originalArgs;
        if (routeId) {
          state.routes.stopMap[routeId] = action.payload;
        }
      });
  },
});
//Actions
export const { removeRoute } = routesReducer.actions;
export const routesSelectors = routesAdapter.getSelectors<RootState>(state => state.routesReducer.routes);
export const routeCountSelector = (state: RootState) => state.routesReducer.routes.count;
export const stopsByRouteId = createSelector(
  [(state: RootState) => state.routesReducer.routes.stopMap, (_: RootState, routeId: string) => routeId],
  (map, routeId) => map[routeId] ?? emptyArray,
);
